import {Box, styled} from "@mui/material";

export const Row = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'row',
}));